import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from "@angular/core";
import { PhxLinkBackground } from "./phx-link.types";
import { PHX_BACKGROUND } from "../../constants";

@Component({
  selector: '[phx-link]',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./phx-link.component.scss'],
  host: {
    class: 'phx-link phx-web-type-body-medium',
    '[class.phx-link-standard]': "phxBackground === PHX_BACKGROUND.STANDARD",
    '[class.phx-link-inverted]': "phxBackground === PHX_BACKGROUND.INVERTED",
    '[class.phx-link-dark]': "phxBackground === PHX_BACKGROUND.DARK",
    '[class.phx-link-summary]': "phxBackground === PHX_BACKGROUND.SUMMARY"
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhxLinkComponent {
  @Input() public phxBackground: PhxLinkBackground = 'standard';

  public readonly PHX_BACKGROUND = PHX_BACKGROUND;
}
